module.exports = ".error {\n  font-family: courier;\n  font-size: 9pt;\n}\n"